import React from 'react';
import { Modal, Icon } from 'antd';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { setIcon } from '../../services/setIcon';

import './style.css';

const ModalFormComponent = ({ title, id, visibility, children, icon, extraFunctionClose }) => {
  const dispatch = useDispatch();
  const modals = useSelector((state) => state.modals);
  const isVisible = (visibility === 'byModalId' ? modals.showingUp[id] : visibility) || false;
  const member = useSelector((state) => state.authentication.loy3Profile);

  const isCloseWindowPermited = (!member ? false: true);

  const onCancel = () => {
    dispatch({ type: 'SET_MODAL', key: id, val: false });
    if (extraFunctionClose) {
      extraFunctionClose();
    }
  };

  return (
    <Modal
      visible={isVisible}
      footer={null}
      onCancel={onCancel}
      maskClosable={isCloseWindowPermited}
      keyboard={isCloseWindowPermited}
      closable={isCloseWindowPermited}>
      {title && <h3 className="font-semibold title">{icon && <Icon component={setIcon(icon)} />} {title}</h3>}
      {children}
    </Modal>
  );
}

ModalFormComponent.propTypes = {
  title: PropTypes.string,
  visibility: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  icon: PropTypes.string,
  extraFunctionClose: PropTypes.func,
};

export default ModalFormComponent;
